import * as React from 'react';
import DropdownItem from 'reactstrap/lib/DropdownItem';

interface Props {
    text: string;
    searchTerms: string;
    handleClick: () => void;
}

interface BoldedText {
    start: string;
    middle: string;
    end: string;
}

const SearchResultDropdownItem = (props: Props) => {
    const boldMatchingPortion: (fullText: string) => BoldedText = fullText => {
        let startIndex = fullText.toLowerCase().indexOf(props.searchTerms.toLowerCase());

        if (startIndex === -1) {
            return { start: fullText, middle: '', end: '' };
        }

        let endIndex = startIndex + props.searchTerms.length;

        return {
            start: fullText.slice(0, startIndex),
            middle: fullText.slice(startIndex, endIndex),
            end: fullText.slice(endIndex)
        };
    };

    const formatBoldedText = (text: BoldedText) => (
        <>
            {text.start}
            {<b>{text.middle}</b>}
            {text.end}
        </>
    );

    return (
        <>
            <DropdownItem onClick={() => props.handleClick()}>
                {formatBoldedText(boldMatchingPortion(props.text))}
            </DropdownItem>
        </>
    );
};

export default SearchResultDropdownItem;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/properties/SearchResultDropdownItem.tsx